<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419FFF !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419FFF;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419FFF;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419FFF;

}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419FFF;
}

.storage-chart-form-inline .el-form-item__label {
  color: white;
}

.storage-chart-form-inline .el-input__inner {
  background-color: #303133;
  color: white;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid"
            style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR',!store.state.is_monitor_full)"
                style="width: 176px;height: 38px;"
                src="../../../../assets/img/web/workshop/logo.png"/>
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            {{store.state.customer.shortName}}-{{$t('chengpincangchutu')}}
          </div>
          <div class="monitorWorshop"
              style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{store.state.currentTime}}</p>
            <div style="display: flex;align-items: center;">

              <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;"
                  icon="yicon yicon-pencil">
                {{$t('bianjikanban')}}
              </el-link>
            </div>
          </div>
        </div>
      </div>

      <div ref="searchBar" style="padding: 14px 34px  0px  34px;">
        <div class="module-grid"
            style="border-radius: 2px;width: 100%;height: 66px;padding:20px 20px;display: flex;justify-content: space-between;align-items: center;">
          <el-form size="mini" :inline="true" :model="conditions" class="storage-chart-form-inline">
            <el-form-item :label="$t('cangkumingcheng')">
              <!-- 跨组件 - 仓库/库区/库位 warehouseIds的值说明:
              1.一次最多会传3个值到接口
              2.如果是3个值,那么第0位是仓库id(1开头),第二位是库区id(2开头),第三位是库位id(3开头),
              3.如果是2个值,那么第0位是库区id(2开头),第1位是库位id(3开头)
              4.如果是1个值,那么第0位是库位的值(3开头),后端收到请求后需截取掉第一位才能得到真正的id
              5.yt.conditions.test 用于clear()清除使用,无需理会;
              -->
              <yi_data_select :type="'warehouse'" :ids.sync="conditions.ids"
                  :idsPath.sync="conditions.warehouseIds">
              </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('kuweibianma')">
              <el-input v-model="conditions.warehouseLocationCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kucunzhuangtai')">
              <el-select v-model="conditions.status">
                <el-option :label="$t('youkucun')" :value="2"></el-option>
                <el-option :label="$t('wukucun')" :value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button @click="handleClick(conditions)" type="primary" plain="plain" style="background-color: black;">
                {{$t('sousuo')}}
              </el-button>
              <el-button @click="resetHandleClick(conditions)" style="background-color: black; color: white;">
                {{$t('chongzhi')}}
              </el-button>
              <yi_curd_expand_button></yi_curd_expand_button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight!=0" :layout.sync="layout" :col-num="24" :maxRows="24"
            :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false"
            :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true"
            :style="{'height': gridContainerHeight+'px'}" style="overflow: auto;">

          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i"
              :key="item.i">
            <component :ref="'grid_'+item.i" v-bind:is="item.i" :orgId="orgId">
            </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>

    <el-dialog :show-close="true" :title="$t('cangchushuju')" :visible.sync="isShowEquipment"
        :close-on-click-modal="false" width="874px" append-to-body>
      <div style="height: 500px;display: flex;flex-direction: column;overflow: hidden;">
        <inventory v-if="isShowEquipment" :equipment="currentEquipment" style="height: 500px"></inventory>
      </div>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t('kapianshezhi')" :visible.sync="isShowBoardEdit"
        :close-on-click-modal="false" width="874px" append-to-body>
      <setting ref="setting"></setting>
      <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowBoardEdit= false">{{$t('quxiao')}}</el-button>
				<el-button size="mini" @click="$refs.setting.save();isShowBoardEdit= false" type="primary">
					{{$t('baocun')}}
				</el-button>
			</span>
    </el-dialog>

  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import card from '@@/pages/web/monitor/storage_chart/card';
import setting from '@@/pages/web/monitor/storage_chart/setting';
import inventory from '@@/pages/web/monitor/storage_chart/material_inventory'

export default {
  name: 'web_monitor_store_chart_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    card: card,
    setting: setting,
    inventory: inventory,
  },

  data() {
    return {
      isShowBoardEdit: false,
      orgId: this.store.state.organizations[0].id,
      currentEquipment: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      conditions: {
        warehouseLocationCode: '',
        warehouseIds: '',
        status: '',
      },
      layout: [
        {
          "x": 0,
          "y": 0,
          "w": 24,
          "h": 24,
          "i": "card"
        },

      ],
      isShowEquipment: false,
    };
  },
  created() {
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true)

    this.utils.event_hub.$on("SHOW_WORKSHOP_EQUIPMENT", (eq) => {
      this.currentEquipment = eq
      this.isShowEquipment = true
    })
    this.utils.event_hub.$on("HIDE_WORKSHOP_EQUIPMENT", () => {
      this.isShowEquipment = false
    })
  },
  activated() {
    this.resize()
  },
  mounted() {
    this.resize()
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize()
    });
  },
  destroyed() {
  },
  methods: {
    handleClick() {
      this.utils.event_hub.$emit('STORE_CHART_SEARCH_CONDITIONS', this.conditions)
    },
    resetHandleClick() {
      this.conditions = {};
      this.utils.event_hub.$emit('STORE_CHART_SEARCH_CONDITIONS', this.conditions)
    },
    showBoardEdit() {
      this.isShowBoardEdit = true
      this.$nextTick(() => {
        this.$refs.setting.resetData()
      })
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header
            .offsetHeight - this.$refs.searchBar.offsetHeight - 34
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24
      }, 500)

    },

  }
};
</script>
